import {Component, OnInit} from '@angular/core';
import {NotificationsService} from '../../services/notifications.service';
import {INpaUmsConfig, INpaUmsData} from 'npa-ums/src/app/remark/remark.types';
import {IRemarkUserPosition} from '../../types/general.types';
import {RemarkService} from '../../services/remark.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ItemService} from '../../../../services/item.service';
import {TranslateService} from '../../services/translate.service';
import {environment as localEnvironment} from '../../../../../environments/environment';
import {environment as productionEnvironment} from '../../../../../environments/environment.prod';
import {Router} from '@angular/router';

@Component({
    selector: 'app-remark-dialog',
    templateUrl: './remark-dialog.component.html',
    styleUrls: ['./remark-dialog.component.styl']
})
export class RemarkDialogComponent implements OnInit {
    env = localEnvironment || productionEnvironment;
    remarkConfig: INpaUmsConfig = undefined;
    remarkData: INpaUmsData = undefined;

    constructor(public notificationsService: NotificationsService,
                private remarkService: RemarkService,
                public itemService: ItemService,
                public translateService: TranslateService,
                private router: Router) {
    }

    ngOnInit() {
        this.remarkService.getPositions().subscribe(
            (remarkData: IRemarkUserPosition) => {
                this.remarkConfig = {
                    lang: this.translateService.lang,
                    remark_type: 'team',
                    system_slug: 'aets',
                    logged_in_user: remarkData.logged_in_user,
                    positions: remarkData.positions,
                    current_link: this.env.baseUrl.aets.frontEnd + this.router.url.substr(1),
                };
                this.remarkData = {
                    identification_number: this.itemService.info.getValue().data.procurement_number
                };
            }, (error: HttpErrorResponse) => {
                this.notificationsService.error(error);
            }
        );
    }
}
